import React from "react";
import { Paper, Stack, Typography, Box, Button } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DescriptionIcon from "@mui/icons-material/Description";
import EventNoteIcon from "@mui/icons-material/EventNote";

/**
 * Accesos rápidos para crear tareas comunes de un empleado general.
 * Cada acción abre el TaskModal con valores pre-cargados (título sugerido,
 * categoría y prioridad). Las categorías usadas existen en TASK_CATEGORIES
 * (documentation / other / follow_up) para no romper el binding del backend.
 */
const ACTIONS = [
  { label: "Observation",   Icon: VisibilityIcon,          color: "#0891B2", defaults: { title: "Observation: ", category: "documentation", priority: "medium" } },
  { label: "Reminder",      Icon: NotificationsActiveIcon, color: "#D97706", defaults: { title: "Reminder: ",    category: "other",         priority: "medium" } },
  { label: "Admin Task",    Icon: AssignmentTurnedInIcon,  color: "#2563EB", defaults: { title: "",              category: "other",         priority: "medium" } },
  { label: "Documentation", Icon: DescriptionIcon,         color: "#7C3AED", defaults: { title: "",              category: "documentation", priority: "low" } },
  { label: "Follow-up",     Icon: EventNoteIcon,           color: "#16A34A", defaults: { title: "Follow-up: ",   category: "follow_up",     priority: "medium" } },
];

export default function QuickActions({ onQuickCreate }) {
  return (
    <Paper
      elevation={0}
      sx={{ p: 2.5, borderRadius: 3, border: "1px solid", borderColor: "divider" }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#ECFEFF",
              color: "#0891B2",
            }}
          >
            <BoltIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Quick Actions
          </Typography>
        </Stack>

        {/* Action buttons — auto-fit para que envuelvan sin desbordar */}
        <Box
          sx={{
            display: "grid",
            gap: 1.5,
            gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
          }}
        >
          {ACTIONS.map(({ label, Icon, color, defaults }) => (
            <Button
              key={label}
              variant="outlined"
              startIcon={<Icon sx={{ fontSize: 18 }} />}
              onClick={() => onQuickCreate(defaults)}
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.8rem",
                borderRadius: 2,
                color,
                borderColor: "divider",
                "&:hover": { borderColor: color, bgcolor: `${color}0A` },
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
      </Stack>
    </Paper>
  );
}
